/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_Empty_BodyInputs */

const en_shopping_empty_body = /** @type {(inputs: Shopping_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan cook sessions for this range or put a recipe on the list, and what you need shows up here.`)
};

const de_shopping_empty_body = /** @type {(inputs: Shopping_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plane Kochsessions für diesen Zeitraum oder setze ein Rezept auf die Liste, dann steht hier, was du brauchst.`)
};

/**
* | output |
* | --- |
* | "Plan cook sessions for this range or put a recipe on the list, and what you need shows up here." |
*
* @param {Shopping_Empty_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_empty_body = /** @type {((inputs?: Shopping_Empty_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Empty_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_empty_body(inputs)
	return en_shopping_empty_body(inputs)
});